/* ═══════════════════════════════════════════
   COLLIES CLUB — Global JavaScript
   ═══════════════════════════════════════════ */

(function() {
  'use strict';

  /* ── Sticky Header Shadow ── */
  const header = document.querySelector('.header');
  if (header) {
    window.addEventListener('scroll', function() {
      header.classList.toggle('scrolled', window.scrollY > 10);
    }, { passive: true });
  }

  /* ── Mobile Nav ── */
  const menuToggle = document.querySelector('.header__menu-toggle');
  const mobileNav = document.querySelector('.mobile-nav');
  const mobileNavClose = document.querySelector('.mobile-nav__close');
  const mobileNavOverlay = document.querySelector('.mobile-nav__overlay');

  function openMobileNav() {
    if (mobileNav) {
      mobileNav.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
  }

  function closeMobileNav() {
    if (mobileNav) {
      mobileNav.classList.remove('is-open');
      document.body.style.overflow = '';
    }
  }

  if (menuToggle) menuToggle.addEventListener('click', openMobileNav);
  if (mobileNavClose) mobileNavClose.addEventListener('click', closeMobileNav);
  if (mobileNavOverlay) mobileNavOverlay.addEventListener('click', closeMobileNav);

  /* ── Cart Drawer ── */
  const cartToggle = document.querySelector('[data-cart-toggle]');
  const cartDrawer = document.querySelector('.cart-drawer');
  const cartClose = document.querySelector('.cart-drawer__close');
  const cartOverlay = document.querySelector('.cart-drawer__overlay');

  function openCart() {
    if (cartDrawer) {
      cartDrawer.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
  }

  function closeCart() {
    if (cartDrawer) {
      cartDrawer.classList.remove('is-open');
      document.body.style.overflow = '';
    }
  }

  if (cartToggle) cartToggle.addEventListener('click', openCart);
  if (cartClose) cartClose.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  /* ── Product Variant Selection ── */
  document.querySelectorAll('.product__color-swatch').forEach(function(swatch) {
    swatch.addEventListener('click', function() {
      this.closest('.product__color-swatches').querySelectorAll('.product__color-swatch').forEach(function(s) {
        s.classList.remove('active');
      });
      this.classList.add('active');
    });
  });

  document.querySelectorAll('.product__size-option').forEach(function(option) {
    option.addEventListener('click', function() {
      this.closest('.product__size-options').querySelectorAll('.product__size-option').forEach(function(o) {
        o.classList.remove('active');
      });
      this.classList.add('active');
    });
  });

  /* ── Product Gallery Thumbnails ── */
  document.querySelectorAll('.product__gallery-thumb').forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      var mainImg = this.closest('.product__gallery').querySelector('.product__gallery-main img');
      var newSrc = this.querySelector('img').getAttribute('src');
      if (mainImg && newSrc) {
        mainImg.setAttribute('src', newSrc);
      }
      this.closest('.product__gallery-thumbs').querySelectorAll('.product__gallery-thumb').forEach(function(t) {
        t.classList.remove('active');
      });
      this.classList.add('active');
    });
  });

  /* ── Scroll Animations ── */
  if ('IntersectionObserver' in window) {
    var animateEls = document.querySelectorAll('[data-animate]');
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-in');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    animateEls.forEach(function(el) { observer.observe(el); });
  }

  /* ── Newsletter Form ── */
  var newsletterForm = document.querySelector('.newsletter__form');
  if (newsletterForm) {
    newsletterForm.addEventListener('submit', function(e) {
      var btn = this.querySelector('button');
      if (btn) btn.textContent = 'Joining...';
    });
  }

  /* ── Free Shipping Bar Update ── */
  function updateFreeShippingBar(cartTotal) {
    var threshold = 5000; // $50.00 in cents
    var bar = document.querySelector('.cart-drawer__free-shipping-progress');
    var text = document.querySelector('.cart-drawer__free-shipping');
    if (bar && text) {
      var pct = Math.min((cartTotal / threshold) * 100, 100);
      bar.style.width = pct + '%';
      if (cartTotal >= threshold) {
        text.querySelector('span').textContent = 'You\'ve unlocked FREE shipping! 🎉';
      } else {
        var remaining = ((threshold - cartTotal) / 100).toFixed(2);
        text.querySelector('span').textContent = 'You\'re $' + remaining + ' away from FREE shipping!';
      }
    }
  }

})();
